module.exports = __webpack_public_path__ + "static/img/mss-3.4da23f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mss/mss-3.png
// module id = 2Qx/
// module chunks = 1